import { render, staticRenderFns } from "./PathDrawer.vue?vue&type=template&id=2a3f1b5c&scoped=true"
import script from "./PathDrawer.vue?vue&type=script&lang=js"
export * from "./PathDrawer.vue?vue&type=script&lang=js"
import style0 from "./PathDrawer.vue?vue&type=style&index=0&id=2a3f1b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f1b5c",
  null
  
)

export default component.exports